import { TourKeys } from '@cast/constants';

import { TourConfig } from 'core/tour-v2/TourConfig';

import { pageTourSteps } from './tour-steps';

export const OpinionatedPlatformTour = () => (
  <TourConfig tourKey={TourKeys.OpinionatedPlatform} steps={pageTourSteps} />
);
